module.exports = __webpack_public_path__ + "img/machine_luke.3c021273.png";